import { Loader2 } from "lucide-react";

/**
 * UploadingBadge — konsistenter Lade-Indikator (Spinner + Label)
 * für ALLE Upload-Punkte in der App (Story, Post, Avatar, Reel, Listing …).
 *
 * Props:
 *   - active: boolean (steuert Sichtbarkeit)
 *   - label:  optionaler Text (Default „Wird hochgeladen …")
 *   - size:   "sm" | "md"  (Default „sm")
 *   - testid: optional
 */
export default function UploadingBadge({ active, label = "Wird hochgeladen …", size = "sm", testid = "uploading-badge" }) {
  if (!active) return null;
  const iconSize = size === "md" ? 16 : 12;
  const textCls = size === "md" ? "text-xs" : "text-[10px]";
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center gap-1.5 text-[#0A0A0A] ${textCls}`}
      role="status"
      aria-live="polite"
    >
      <Loader2 size={iconSize} className="animate-spin text-[#0A0A0A]" />
      <span>{label}</span>
    </span>
  );
}
